import { FactCheck as ComplianceIcon } from '@mui/icons-material';

interface ComplianceStatusBadgeProps {
  commercialName: string | undefined;
  classes: string;
  hideIcon?: boolean;
}

const ComplianceStatusBadge = ({
  commercialName,
  classes,
  hideIcon = false,
}: ComplianceStatusBadgeProps) => {
  if (!commercialName) return null;

  return (
    <div
      className={`flex items-center gap-1.5 text-[14px] font-black uppercase px-2.5 py-1 rounded-md w-fit ${classes}`}
    >
      {!hideIcon && <ComplianceIcon sx={{ fontSize: 16 }} />}
      {commercialName}
    </div>
  );
};

export default ComplianceStatusBadge;
